import type { ModalUICopy, ScreenUICopy } from '@polyai/ui/uiCopy/types';

import type { CardColumnUICopy } from 'uiCopy/types';

const screenUICopy: ScreenUICopy<string, string> = {
  pageTitle: 'Flows',
  pageDescription:
    'Allow your agent to follow step by step instructions for complex tasks like reservations.',
};

const deleteFlowModal: Omit<ModalUICopy<string, string>, 'button'> = {
  title: 'Delete this flow?',
  description: 'Are you sure you want to delete this flow?',
};

const descriptionColumn: Omit<CardColumnUICopy, 'empty'> = {
  title: 'Description',
};

export const FLOWS = {
  ...screenUICopy,
  button: {
    add: 'Flow',
  },
  flowsCount: (flowsCount: number) => `${flowsCount} flows`,
  empty: {
    title: 'You have no flows so far',
    description: 'Click on "Add flow" button to create your own',
  },
  card: {
    description: descriptionColumn,
    popupMenu: {
      edit: 'Edit',
      duplicate: 'Duplicate',
      delete: 'Delete',
      view: 'View',
    },
    modal: {
      delete: deleteFlowModal,
    },
  },
  creation: {
    defaultCondition: {
      label: 'All entities collected',
      description: 'Condition description',
    },
    startStep: {
      name: 'Start step',
    },
    endStep: {
      name: 'End step',
    },
    transitionFunction: {
      start: {
        description: 'Transition to the end step',
        parameter: {
          description: 'The name of the user',
        },
      },
      end: {
        description: 'Leave this flow',
      },
    },
    description: (name: string) => `Description for flow ${name}`,
  },
} as const;
